<template>
  <div
    v-if="isValidPassAndCenteredQR"
    class="ticket-name-label"
    :style="{
      backgroundColor: upperColors.backgroundColor,
      color: upperColors.fontColor,
    }"
  >
    <div class="ticket-icon">
      <img
        v-show="isConditionMet"
        :src="require('@/assets/img/icon/svg/icon_ticket.svg')"
        alt="黒色のチケットアイコン"
      />
      <img
        v-show="!isConditionMet"
        :src="require('@/assets/img/icon/svg/icon_ticket_white.svg')"
        alt="白色のチケットアイコン"
      />
    </div>
    {{ passName }}
  </div>
</template>

<script>
export default {
  name: "CenteredQRTicketNameLabel",
  props: {
    isValidPassAndCenteredQR: {
      type: Boolean,
      required: true,
    },
    passName: {
      type: String,
      required: true,
    },
    upperColors: {
      type: Object,
      required: false,
      default: () => ({
        backgroundColor: "#ffffff",
        fontColor: "#000000",
      }),
    },
  },
  computed: {
    isConditionMet() {
      return this.upperColors?.fontColor === "#000000";
    },
  },
};
</script>

<style lang="scss" scoped>
.ticket-name-label {
  display: flex;
  color: #ffffff;
  padding: 2.67vw;
  height: 12.8vw;
  font-weight: 700;
  font-size: 5.33vw;
  align-items: center;
}

.ticket-icon {
  width: 7.47vw;
  height: 7.47vw;
  margin-right: 3.73vw;
}
</style>
